import React, {useState, useContext} from "react";
import Menu from "../components/Menu";
import {HomePage, HomeContent, OfferInfo, DiscountInfo} from "../styles";
import Toast from 'light-toast';
import {UserContext} from "../context/UserContext";
import { FiTag } from "react-icons/fi";
import {OffersService} from "../services/offers-service";
import { Modal, Row, Col, Spinner, Accordion, Card, Alert, Dropdown, Container } from 'react-bootstrap';
import { FaBan, FaInfo, FaGift, FaCheckCircle} from "react-icons/fa";

let rp = 0;
const status = [
    {
        id: -1,
        name: "Ver Tudo"
    }, {
        id: 1,
        name: "Activas"
    }, {
        id: 0,
        name: "Inactivas"
    }
]
function Offers() {
    const [offers, setOffers] = useState([]);
    const [load, setLoad] = useState(false);
    const [aActived, setaActived] = useState(null);
    const [s_status, setSstatus] = useState(status[0]);
    const [user] = useContext(UserContext);

    function getOffers(status_id = -1) {
        rp++;
        setLoad(true);
        OffersService.location_offers_with_status(user.token, user.location_id, status_id).then((result) => {
            if(result.total > 0) {
                setOffers(result.offers);
                setLoad(false);
            } else {
                setOffers([]);
                Toast.info('Nenhuma Oferta Disponível.', 3000);
                setLoad(false);
            }
            rp = 0;
        });
    }

    if(user.token && user.location_id && offers.length === 0 && rp === 0) {
        getOffers(s_status.id);
    }

    function offerDate(start, end) {
        let startdate = "XX-XX-XXXX";
        let enddate = "XX-XX-XXXX";
        if(start) {
          const s = start.substring(0, 10).split('-');
          startdate = s[2] + '-' + s[1] + '-' + s[0];
        }
        if(end) {
          const s = end.substring(0, 10).split('-');
          enddate = s[2] + '-' + s[1] + '-' + s[0];
        }
        return startdate + ' - ' + enddate;
    }

    function cardClicked(item) {
        if(aActived === item.offer_id) {
          setaActived(null);
        } else {
          setaActived(item.offer_id);
        }
    } 

    function statusChange(item) {
        setSstatus(item);
        getOffers(item.id);
    }

    let statusItems = status.map((item, index) => {
        return (
            <Dropdown.Item key={item.id} onSelect={()=> statusChange(item)}>{item.name}</Dropdown.Item>
        )
    });


    let listItems = offers.map((item, index) => {
        let alertMessage;
        if(item.status === "0") {
            alertMessage = <Alert size="sm" variant="danger">Oferta não disponível.</Alert>;
        }

        return(
        <Card key={item.offer_id}>
            <Card.Header>
            <div className="discount_top"><h3>{item.title}</h3></div>
            
            {item.status === "1" ? 
            <FaCheckCircle size={25} color="#28a745"/> : <FaBan size={25} color="#BF2F38"/>}

            </Card.Header>
            <Card.Body>
            <div className="header_bottom">
                <DiscountInfo>
                {item.offer_type_id === "3" ? 
                    <h3><FaGift /></h3>
                : null}
                {item.offer_type_id === "2" ? 
                    <div>
                    <span className="money">{item.discount}</span>
                    <span className="ao"> Kz</span>
                    </div> 
                : null}
                {item.offer_type_id === "1" ? <div><span className="money">{item.discount}</span>% </div>: null}

                {item.is_medicare === "1" && item.is_not_medicare === "0" ? <span className="badge exclusivo">Exclusivo</span> : null}
                </DiscountInfo>
                <FaInfo className="viewMore" onClick={(e)=> cardClicked(item)}/>
            </div>
            
            <Accordion.Collapse eventKey={item.offer_id}>
            <div>
                <Row>
                    <Col>
                    <hr/>  
                    <OfferInfo>
                        
                        <div className="others">
                        <span className="days">
                            {item.valid_weekday_0 === "1" ? "Seg |" : null}
                            {item.valid_weekday_1 === "1" ? " Ter |" : null}
                            {item.valid_weekday_2 === "1" ? " Qua |" : null}
                            {item.valid_weekday_3 === "1" ? " Qui |" : null}
                            {item.valid_weekday_4 === "1" ? " Sex |" : null}
                            {item.valid_weekday_5 === "1" ? " Sáb |" : null}
                            {item.valid_weekday_6 === "1" ? " Dom" : null}
                            <br />
                            {offerDate(item.date_in, item.date_out)}
                        </span>
                        
                        </div>
                    </OfferInfo>
                    <div className="text-description" dangerouslySetInnerHTML={{ __html: item.description }} ></div>
                    </Col>
                </Row>

                {alertMessage}
                </div>
            </Accordion.Collapse>
            </Card.Body>
        </Card>
        )
    });

    return(
        <HomePage>
            <Menu locations={true} page="offers" />
            <HomeContent>
                <div className="pageTitle"><FiTag />Ofertas e Descontos</div>
                <Container>  
                    <div className="pl-3 pr-3">
                        <div className="text-center" >
                            <Dropdown>
                                <Dropdown.Toggle variant="danger">
                                {s_status.name}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                {statusItems}
                                </Dropdown.Menu>  
                            </Dropdown>
                        </div>

            
                        <div className="mt-3" >
                            {/* <h3 className="title">DESCONTOS E OFERTAS</h3>   */}
                            <Accordion activeKey={aActived} className="myAccordion">
                                {listItems}
                            </Accordion>
                            <Modal
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                                show={load}
                                onHide={() => setLoad(true)}
                                className="trasnp"
                            >
                                <Modal.Body>
                                    <Spinner animation="border" role="status" style={{color:'white'}}>
                                    </Spinner>
                                    <span className="sr-only">Loading...</span>
                                </Modal.Body>
                            </Modal>
                        </div>
                    </div>
                    </Container>
            </HomeContent>
        </HomePage>
    )
}

export default Offers;